import { useEffect, useState } from "react";
import { getReconLogs } from "../../../data/DynamicTable/DynamicFunctions";
 // Adjust the import path as needed
import { 
  Table, TableBody, TableCell, TableContainer, TableHead, 
  TableRow, Paper, Typography, CircularProgress, Alert 
} from "@mui/material";

const LogComponent = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
// Function to format the TransTime
const formatTransTime = (transTime) => {
    if (!transTime) return "N/A"; // Handle null values
  
    // Extract year, month, day, hour, minute, second
    const year = transTime.substring(0, 4);
    const month = transTime.substring(4, 6);
    const day = transTime.substring(6, 8);
    const hour = transTime.substring(8, 10);
    const minute = transTime.substring(10, 12);
    const second = transTime.substring(12, 14);
  
    // Create a Date object
    const formattedDate = new Date(`${year}-${month}-${day}T${hour}:${minute}:${second}`);
  
    // Format using locale date-time string
    return formattedDate.toLocaleString(); // Converts to readable format
  };
  
 
  
  useEffect(() => {
    const fetchLogs = async () => {
      setLoading(true);
      const data = await getReconLogs();
      if (data.error) {
        setError(data.error);
      } else {
        setLogs(data);
      }
      setLoading(false);
    };

    fetchLogs();
  }, []);

  return (
    <TableContainer component={Paper} sx={{ margin: 2, padding: 2 }}>
      <Typography variant="h6" gutterBottom sx={{ padding: 1 }}>
        Transaction Logs
      </Typography>

      {loading ? (
        <CircularProgress sx={{ display: "block", margin: "auto" }} />
      ) : error ? (
        <Alert severity="error">{error}</Alert>
      ) : (
        <Table>
          <TableHead>
            <TableRow>
              <TableCell><strong>Bill Ref Number</strong></TableCell>
              <TableCell><strong>Transaction ID</strong></TableCell>
              <TableCell><strong>Transaction Type</strong></TableCell>
              <TableCell><strong>Amount</strong></TableCell>
              <TableCell><strong>Time</strong></TableCell>
              <TableCell><strong>Response</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {logs.map((log, index) => (
              <TableRow key={index}>
                <TableCell>{log.BillRefNumber}</TableCell>
                <TableCell>{log.TransID}</TableCell>
                <TableCell>{log.TransactionType}</TableCell>
                <TableCell>{log.TransAmount}</TableCell>
                <TableCell>{formatTransTime(log.TransTime)}</TableCell>
                <TableCell>{log.Response? log.Response : "N/A"}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </TableContainer>
  );
};

export default LogComponent;
